import { Routes, RouterModule } from '@angular/router'
import { ModuleWithProviders } from '@angular/core'
import {
  authGuard,
  DynRouteInitComponent,
  DynRouteInitCompGuard,
  dynRouteGuard,
  LoginComponent,
  ConnectionFailedComponent,
  root,
  NotFoundComponent,
  DashboardComponent
} from '@dot-it/jml-lib'

import { LayoutComponent } from './layout/layout/layout.component'
import { PlaygroundGuard } from './playground/guards/playground.guard'
import { customLibRoutes } from 'projects/custom-lib/src/public-api'
import { LayoutFullscreenComponent } from './layout-fullscreen/layout-fullscreen.component'
import { UserProfileComponent } from '@dot-it/jml-lib'

export const routes: Routes = [
  // App-Layout routes
  {
    path: '',
    component: LayoutComponent,
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    children: [
      ...customLibRoutes,
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        component: DashboardComponent,
        // the current landing page can not have a guard, except to check if the user is logged in. but that is already checked one level above with the authguard.
        // canActivate: [JmlPermissionGuard],
        data: {
          permissions: [root.Menuitems.dashboard]
        }
      },
      {
        path: 'profile',
        component: UserProfileComponent
      },
      {
        path: 'playground',
        loadChildren: () => import('./playground/playground.module').then((m) => m.PlaygroundModule),
        canLoad: [PlaygroundGuard]
      },
      // pickup-path for initializing dynamic routes
      {
        path: 'init',
        component: DynRouteInitComponent,
        canActivate: [DynRouteInitCompGuard]
      },
      {
        path: 'not-found',
        component: NotFoundComponent
      }
    ]
  },

  // Layout-Fullscreen routes
  {
    path: '',
    component: LayoutFullscreenComponent,
    children: [
      {
        path: 'login',
        redirectTo: 'login/',
        pathMatch: 'full'
      },
      {
        path: 'login/:uploadLicenseMessage',
        component: LoginComponent
      },
      {
        path: 'connection-failed',
        component: ConnectionFailedComponent
      }
    ]
  },

  {
    path: '**',
    component: NotFoundComponent,
    pathMatch: 'full',
    canActivate: [dynRouteGuard]
  }
]

export const AppRoutes: ModuleWithProviders<RouterModule> = RouterModule.forRoot(routes, {
  scrollPositionRestoration: 'enabled'
})
